import { render, staticRenderFns } from "./list.vue?vue&type=template&id=75d61b3d&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d61b3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d61b3d')) {
      api.createRecord('75d61b3d', component.options)
    } else {
      api.reload('75d61b3d', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=75d61b3d&scoped=true", function () {
      api.rerender('75d61b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/operationManagement/commodityRestriction/list.vue"
export default component.exports